const ToastActionTypes = {
    START_TOAST_DISPLAY: 'START_TOAST_DISPLAY',
    FINISH_TOAST_DISPLAY: 'FINISH_TOAST_DISPLAY',
}

export default ToastActionTypes
